import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  TableContainer,
  Paper,
  Typography,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router-dom';
import useMetadata from './hooks/useEditMetadata';

function EditMetadata() {
  const history = useHistory();

  const {
    keyNames,
    selectedKey,
    setSelectedKey,
    filteredData,
    openModal,
    setOpenModal,
    isEditMode,
    form,
    setForm,
    openEditModal,
    openAddModal,
    saveMetadata,
    openDeleteModal,
    setOpenDeleteModal,
    handleOpenDeleteModal,
    handleDeleteMetadata,
  } = useMetadata();

  return (
    <div style={{ width: '100%', height: 'calc(100vh - 150px)', background: '#fafafa', padding: 16 }}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <h2 style={{ margin: 0, fontWeight: 600 }}>Edit Metadata</h2>
        <Button variant="contained" onClick={() => history.push('/')}>
          Home
        </Button>
      </Box>

      <Box display="flex" gap={2} mb={3}>
        <Select
          value={selectedKey}
          onChange={e => setSelectedKey(e.target.value)}
          displayEmpty
          size="small"
          style={{ minWidth: 250 }}>
          <MenuItem value="">Select Key Name</MenuItem>
          {keyNames.map(key => (
            <MenuItem key={key} value={key}>
              {key}
            </MenuItem>
          ))}
        </Select>

        <Button variant="contained" disabled={!selectedKey} startIcon={<AddIcon />} onClick={openAddModal}>
          Add Metadata
        </Button>
      </Box>

      {selectedKey && (
        <Box
          sx={{
            maxWidth: '95%', // <<< adjust as you like (700, 900, 600, etc.)
            mx: 'auto', // center the table
            px: 2, // left/right padding inside container
          }}>
          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              border: '1px solid #e5e7eb',
              borderRadius: '6px',
              marginTop: '50px',
            }}>
            <Table
              size="small"
              sx={{
                width: '100%',
                tableLayout: 'fixed',
                '& td, & th': {
                  borderRight: '1px solid #e5e7eb',
                  padding: '6px',
                },
                '& td:last-of-type, & th:last-of-type': {
                  borderRight: 'none',
                },
              }}>
              <TableHead>
                <TableRow sx={{ backgroundColor: '#f3f4f6' }}>
                  <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Key Name</TableCell>
                  <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Key Value</TableCell>
                  <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Edit</TableCell>
                  <TableCell sx={{ fontWeight: 600, textAlign: 'center' }}>Delete</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredData.map(row => (
                  <TableRow key={row.id || row.keyId} hover sx={{ '&:hover': { backgroundColor: '#f9fafb' } }}>
                    <TableCell sx={{ borderBottom: '1px solid #e5e7eb', textAlign: 'center' }}>{row.keyName}</TableCell>

                    <TableCell sx={{ borderBottom: '1px solid #e5e7eb', textAlign: 'center' }}>{row.keyValue}</TableCell>

                    <TableCell sx={{ borderBottom: '1px solid #e5e7eb', textAlign: 'center' }}>
                      <IconButton size="small" onClick={() => openEditModal(row)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </TableCell>

                    <TableCell sx={{ borderBottom: '1px solid #e5e7eb', textAlign: 'center' }}>
                      <IconButton size="small" onClick={() => handleOpenDeleteModal(row)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="sm">
        <DialogTitle>{isEditMode ? 'Edit Metadata' : 'Add Metadata'}</DialogTitle>
        <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <TextField label="Key Name" value={form.keyName} disabled fullWidth />
          <TextField
            label="Key Value"
            value={form.keyValue}
            onChange={e => setForm({ ...form, keyValue: e.target.value })}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveMetadata}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          sx: { borderRadius: 3, p: 1 },
        }}>
        <DialogTitle sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>Delete Metadata</DialogTitle>

        <DialogContent sx={{ mt: 1 }}>
          <Typography sx={{ fontSize: '15px' }}>
            Are you sure you want to delete:
            <strong style={{ marginLeft: 4, fontWeight: 'bold' }}>{form.keyValue}</strong>?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setOpenDeleteModal(false)} sx={{ textTransform: 'none' }}>
            Cancel
          </Button>

          <Button variant="contained" color="error" onClick={handleDeleteMetadata} sx={{ textTransform: 'none' }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default EditMetadata;
